<template>
    <div class="driver-vehicle-management">
        <div class="page-header">
            <h2>{{ $t('driverVehicle.pageTitle') }}</h2>
        </div>

        <div class="content-wrapper">
            <!-- 左侧驾驶员列表 -->
            <div class="driver-section">
                <el-card class="driver-card">
                    <div slot="header" class="card-header">
                        <h3>{{ $t('driverVehicle.driverList') }}</h3>
                        <el-input v-model="driverSearch" placeholder="搜索驾驶员" size="small" style="width: 200px"
                            clearable>
                            <el-button slot="append" icon="el-icon-search" @click="searchDrivers"></el-button>
                        </el-input>
                    </div>
                    <el-table :data="driverList" style="width: 100%" @row-click="selectDriver"
                        :row-class-name="tableRowClassName" highlight-current-row border>
                        <el-table-column prop="DriverID" :label="$t('driverVehicle.driverNo')" min-width="100">
                        </el-table-column>
                        <el-table-column prop="Driver" :label="$t('driverVehicle.driverName')" min-width="120">
                        </el-table-column>
                        <el-table-column prop="ContactNo" :label="$t('driverVehicle.contactNo')" min-width="120">
                        </el-table-column>
                        <el-table-column prop="CarNo" :label="$t('driverVehicle.vehicleNo')" min-width="120">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.CarNo" size="small" type="success">{{ scope.row.CarNo
                                    }}</el-tag>
                                <span v-else class="unbound-text">{{ $t('driverVehicle.unbound') }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <kl-pagination style="margin-bottom: 10px;" :total="driverTotal" @current-change="pageChange"
                        @size-change="sizeChange" :current-page.sync="PageNo">
                    </kl-pagination>
                </el-card>
            </div>

            <!-- 右侧车辆绑定区域 -->
            <div class="vehicle-section">
                <el-card class="vehicle-card">
                    <div slot="header" class="card-header">
                        <h3>{{ $t('driverVehicle.vehicleBind') }}</h3>
                        <span v-if="selectedDriver" class="selected-driver-name">
                            {{ $t('driverVehicle.currentDriver') }}: {{ selectedDriver.Driver }}
                        </span>
                    </div>

                    <div v-if="selectedDriver" class="bind-content">
                        <!-- 当前绑定信息 -->
                        <div class="current-bind-info">
                            <h4>{{ $t('driverVehicle.currentBind') }}</h4>
                            <div v-if="selectedDriver.CarNo" class="binded-info">
                                <el-tag type="success" size="large">
                                    <i class="el-icon-check"></i> {{ $t('driverVehicle.hasVehicle') }}: {{
                                        selectedDriver.CarNo
                                    }}
                                </el-tag>
                                <!-- <el-button type="danger" size="small" @click="unbindVehicle" style="margin-left: 12px;">
                                    {{ $t('driverVehicle.unbindBtn') }}
                                </el-button> -->
                            </div>
                            <div v-else class="unbinded-info">
                                <el-tag type="warning" size="large">
                                    <i class="el-icon-info"></i> {{ $t('driverVehicle.noVehicle') }}
                                </el-tag>
                            </div>
                        </div>

                        <!-- 车辆选择 -->
                        <div class="vehicle-select-section">
                            <h4>{{ $t('driverVehicle.selectVehicle') }}</h4>
                            <el-select v-model="selectedVehicleId" filterable
                                :placeholder="$t('driverVehicle.pleaseSelectVehicle')" style="width: 100%;"
                                size="medium">
                                <el-option v-for="vehicle in availableVehicles" :key="vehicle.vehicleId"
                                    :label="vehicle.carno" :value="vehicle.vID">
                                    <span style="float: left">{{ vehicle.carno }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ vehicle.vehicleselfNo
                                        }}</span>
                                </el-option>
                            </el-select>
                            <el-button type="primary" size="medium" @click="bindVehicle" :loading="binding"
                                style="margin-top: 16px;">
                                {{ $t('driverVehicle.bindBtn') }}
                            </el-button>
                        </div>
                    </div>

                    <div v-else class="empty-tip">
                        {{ $t('driverVehicle.pleaseSelectDriver') }}
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: 'DriverVehicleManagement',
    data() {
        return {
            vehicleList: [],
            driverList: [],
            driverTotal: 0,
            vehicleDriverBindings: [],
            selectedDriver: null,
            selectedVehicleId: '',
            selectedDriverId: null,
            driverSearch: '',
            binding: false,
            PageNo: 1,
            PageSize: 10
        };
    },
    computed: {
        ...mapState({
            size: (state) => state.app.size,
            operator: (state) => state.user.operator,

        }),

        availableVehicles() {
            if (!this.selectedDriver) return this.vehicleList;
            const boundVehicleIds = this.vehicleDriverBindings
                .filter(b => b.driverId !== this.selectedDriver.driverId)
                .map(b => b.vehicleId);
            return this.vehicleList.filter(v => !boundVehicleIds.includes(v.vehicleId));
        }
    },
    watch: {
        driverSearch(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.PageNo = 1;
                this.queryDriverList();
            }
        }
    },
    mounted() {
        this.queryDriverList();
        this.queryVehicleList();


    },
    methods: {
        searchDrivers() {
            this.PageNo = 1;
            this.queryDriverList();
        },
        queryVehicleList() {
            this.$api.queryVehicleinfoList({
                companyID: this.operator.CompanyId,
                pageNo: 1,
                pageSize: 1000,
                BranchName: "",
                OperatorID: this.operator.OperatorId,
            }).then((res) => {
                if (res.code == 200) {
                    this.vehicleList = res.data || [];
                }
            });
        },
        pageChange(page) {
            this.PageNo = page;
            this.queryDriverList();
        },
        sizeChange(size) {
            this.PageSize = size;
            this.queryDriverList();
        },
        queryDriverList() {
            this.$api
                .queryDriverInfo({
                    CompanyID: this.operator.CompanyId,
                    PageNo: this.PageNo,
                    PageSize: this.PageSize,
                    OperatorID: this.operator.OperatorId,
                    DriverName: this.driverSearch,
                    IsExport: 0,
                    CarNo: "",
                }, 'json')
                .then((res) => {
                    this.loading = false;
                    if (res && res.code == 200) {
                        this.driverList = res.data || [];
                        this.driverTotal = res.count || 0;
                    }
                });
        },


        updateBindInfo() {
            this.driverList.forEach(driver => {
                const binding = this.vehicleDriverBindings.find(b => b.driverId === driver.driverId);
                if (binding) {
                    const vehicle = this.vehicleList.find(v => v.vehicleId === binding.vehicleId);
                    driver.vehicleNo = vehicle ? vehicle.vehicleNo : '';
                } else {
                    driver.vehicleNo = '';
                }
            });

            this.vehicleList.forEach(vehicle => {
                const binding = this.vehicleDriverBindings.find(b => b.vehicleId === vehicle.vehicleId);
                if (binding) {
                    const driver = this.driverList.find(d => d.driverId === binding.driverId);
                    vehicle.driverName = driver ? driver.driverName : '';
                } else {
                    vehicle.driverName = '';
                }
            });
        },

        selectDriver(driver) {
            this.selectedDriver = driver;
            this.selectedDriverId = driver.DriverID;
            this.selectedVehicleId = '';
        },

        bindVehicle() {
            if (!this.selectedDriver) {
                this.$message.warning(this.$t('driverVehicle.pleaseSelectDriver'));
                return;
            }
            if (!this.selectedVehicleId) {
                this.$message.warning(this.$t('driverVehicle.pleaseSelectVehicle'));
                return;
            }

            this.binding = true;

            //通过 selectedVehicleId 从 vehicleList 中获取车辆信息
            const vehicle = this.vehicleList.find(v => v.vID === this.selectedVehicleId);
            if (!vehicle) {
                this.$message.error(this.$t('driverVehicle.vehicleNotFound'));
                return;
            }

            //保存修改的数据
            this.$api.modifyVehicleInfo({
                vID: vehicle.vID,
                manufactureId: vehicle.manufactureId,
                vin: vehicle.vin,
                modellevel: vehicle.modellevel,
                carno: vehicle.carno,
                province: vehicle.province,
                industry: vehicle.industry,
                buydate: vehicle.buydate,
                // vehicleownerinfo: modidata.vehicleownerinfo,
                roadTransCerNo: vehicle.roadTransCerNo,
                businessArea: vehicle.businessArea,
                operationalstatus: vehicle.operationalstatus,
                electricityprice: vehicle.electricityprice,
                deviceNo: vehicle.deviceNo,
                vehicleModel: vehicle.vehicleModel,
                vehicleselfNo: vehicle.vehicleselfNo,
                vehicleColor: vehicle.vehicleColor,
                city: vehicle.city,
                deviceType: vehicle.deviceType,
                usedate: vehicle.usedate,
                defaultDriver: this.selectedDriverId,
                businesslicenseNo: vehicle.businesslicenseNo,

                DriverID: this.selectedDriverId,
                runState: vehicle.runState
            }).then((res) => {
                // console.log(res)
                if (res && res.code == 200) {

                    this.selectedVehicleId = '';
                    this.binding = false;
                    this.$message.success(this.$t('driverVehicle.bindSuccess'));
                    this.queryDriverList();
                }
            })


        },

        unbindVehicle() {
            if (!this.selectedDriver) return;

            this.$confirm(
                this.$t('driverVehicle.unbindConfirm', { driverName: this.selectedDriver.Driver }),
                this.$t('public.tips'),
                {
                    confirmButtonText: this.$t('public.confirm'),
                    cancelButtonText: this.$t('public.cancel'),
                    type: 'warning'
                }
            ).then(() => {
                this.vehicleDriverBindings = this.vehicleDriverBindings.filter(
                    b => b.driverId !== this.selectedDriver.driverId
                );
                this.updateBindInfo();
                this.$message.success(this.$t('driverVehicle.unbindSuccess'));
            }).catch(() => { });
        },

        tableRowClassName({ row }) {
            return row.driverId === this.selectedDriverId ? 'selected-row' : '';
        }
    }
};
</script>

<style scoped>
.driver-vehicle-management {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
}

.page-header {
    margin-bottom: 20px;
}

.content-wrapper {
    display: flex;
    gap: 20px;
    height: calc(100% - 80px);
}

.driver-section {
    width: 60%;
    display: flex;
    flex-direction: column;
}

.vehicle-section {
    width: 40%;
    display: flex;
    flex-direction: column;
}

.driver-card,
.vehicle-card {
    height: 100%;
    overflow: auto;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.selected-driver-name {
    color: #409EFF;
    font-size: 14px;
}

.bind-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.current-bind-info h4,
.vehicle-select-section h4 {
    margin-top: 0;
    margin-bottom: 12px;
    color: #303133;
}

.current-bind-info {
    padding: 16px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.binded-info,
.unbinded-info {
    display: flex;
    align-items: center;
}

.vehicle-select-section {
    padding: 16px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.empty-tip {
    text-align: center;
    color: #909399;
    padding: 40px 0;
    font-size: 14px;
}

.unbound-text {
    color: #909399;
}

::v-deep .selected-row {
    background-color: #ecf5ff;
}

::v-deep .el-table__row {
    cursor: pointer;
}
</style>